// =================================================================
// NavSection.js - Composant Navigation Modulaire Oracle TRYA
// Reproduction exacte du style mockup avec permissions granulaires
// =================================================================

import React from 'react';
import { ChevronRight } from 'lucide-react';

const NavSection = ({ 
  icon, 
  title, 
  path, 
  role, 
  moduleAccess, 
  expanded, 
  onToggle, 
  subItems = [],
  collapsed,
  onClick,
  user,
  active = false
}) => {
  
  // Vérification permissions utilisateur
  if (role && user && user.role !== role) return null;
  if (moduleAccess && user && !user.moduleAccess?.[moduleAccess]) return null;

  const handleClick = () => {
    if (subItems.length > 0) {
      onToggle && onToggle();
    } else {
      onClick && onClick(path);
    }
  };

  return (
    <div className="nav-section-container">
      <style>{`
        .nav-section-container {
          margin: 2px 0;
        }

        .nav-item {
          display: flex;
          align-items: center;
          padding: 12px 16px;
          margin: 2px 8px;
          border-radius: 10px;
          cursor: pointer;
          transition: all 0.2s ease;
          font-size: 14px;
          color: var(--sidebar-text);
          font-weight: 500;
          position: relative;
          background: none;
          border: none;
          width: calc(100% - 16px);
          text-align: left;
        }

        .nav-item:hover {
          background: var(--sidebar-active-bg);
          transform: translateX(2px);
          color: var(--sidebar-active);
        }

        .nav-item.active {
          background: var(--sidebar-active-bg);
          color: var(--sidebar-active);
          font-weight: 600;
          border-left: 3px solid var(--sidebar-active);
          margin-left: 3px;
          padding-left: 13px;
        }

        .nav-item.active:hover {
          transform: none;
        }

        .nav-icon {
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 12px;
          font-size: 16px;
        }

        .nav-title {
          flex: 1;
          font-size: 14px;
        }

        .nav-chevron {
          margin-left: auto;
          transition: transform 0.2s ease;
        }

        .nav-chevron.expanded {
          transform: rotate(90deg);
        }

        .sub-items {
          margin-left: 16px;
          padding: 4px 0;
          background: var(--sub-items-bg);
          border-radius: 8px;
          margin-top: 4px;
          margin-bottom: 8px;
          border-left: 2px solid var(--card-border);
        }

        .sub-item {
          display: flex;
          align-items: center;
          padding: 8px 16px;
          margin: 1px 8px;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s ease;
          font-size: 13px;
          color: var(--text-secondary);
          background: none;
          border: none;
          width: calc(100% - 16px);
          text-align: left;
        }

        .sub-item:hover {
          background: var(--sidebar-active-bg);
          color: var(--sidebar-active);
          transform: translateX(2px);
        }

        .sub-item.active {
          background: var(--accent);
          color: white;
          font-weight: 500;
        }

        .sub-icon {
          width: 16px;
          height: 16px;
          margin-right: 8px;
          font-size: 12px;
        }

        .collapsed .nav-title,
        .collapsed .nav-chevron {
          display: none;
        }

        .collapsed .nav-item {
          padding: 12px;
          justify-content: center;
          margin: 4px;
        }
      `}</style>
      
      {/* Navigation principale */}
      <button
        className={`nav-item ${active ? 'active' : ''}`}
        onClick={handleClick}
        title={title}
      >
        <div className="nav-icon">
          {typeof icon === 'string' ? icon : React.isValidElement(icon) ? icon : null}
        </div>
        
        {!collapsed && (
          <>
            <div className="nav-title">{title}</div>
            
            {subItems.length > 0 && (
              <ChevronRight 
                size={14} 
                className={`nav-chevron ${expanded ? 'expanded' : ''}`}
              />
            )}
          </>
        )}
      </button>
      
      {/* Sous-menus */}
      {!collapsed && expanded && subItems.length > 0 && (
        <div className="sub-items">
          {subItems.map((item, index) => (
            <button
              key={index}
              className={`sub-item ${item.active ? 'active' : ''}`}
              onClick={() => onClick && onClick(item.path || item.action)}
            >
              <div className="sub-icon">{item.icon}</div>
              <div>{item.label}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default NavSection;
